module.exports = __webpack_public_path__ + "static/media/index.715d78ed.less";